// In-app workbench tools — React-route pages backed by native engines.
// Distinct from the container-hub registry (config/hubRegistry.ts).
// Each entry corresponds to an explicit <Route> in App.tsx that
// shadows the /workbench/:hubName catch-all.

export interface InAppTool {
  id: string;
  title: string;
  path: string;
  category: string;
}

export const IN_APP_CATEGORIES = [
  'Kinetics & Binding',
  'Molecular Properties',
  'Structure Generation',
  'Pharmacology',
  'Analysis',
] as const;

export const IN_APP_TOOLS: InAppTool[] = [
  { id: 'ic50',              title: 'IC50 Fitting',         path: '/workbench/ic50',              category: 'Kinetics & Binding' },
  { id: 'kinetics',          title: 'Enzyme Kinetics',      path: '/workbench/kinetics',          category: 'Kinetics & Binding' },
  { id: 'spr',               title: 'SPR Analysis',         path: '/workbench/spr',               category: 'Kinetics & Binding' },
  { id: 'admet',             title: 'ADMET Prediction',     path: '/workbench/admet',             category: 'Molecular Properties' },
  { id: 'rdkit-descriptors', title: 'RDKit Descriptors',    path: '/workbench/rdkit-descriptors', category: 'Molecular Properties' },
  { id: 'padel',             title: 'PaDEL Descriptors',    path: '/workbench/padel',             category: 'Molecular Properties' },
  { id: 'quantum',           title: 'Quantum Properties',   path: '/workbench/quantum',           category: 'Molecular Properties' },
  { id: 'library',           title: 'Library Enumeration',  path: '/workbench/library',           category: 'Structure Generation' },
  { id: 'conformers',        title: 'Conformer Generation', path: '/workbench/conformers',        category: 'Structure Generation' },
  { id: 'metabolism',        title: 'Metabolism Analysis',  path: '/workbench/metabolism',        category: 'Pharmacology' },
  { id: 'pkpd',              title: 'PK/PD Modelling',      path: '/workbench/pkpd',              category: 'Pharmacology' },
  { id: 'docking',           title: 'Molecular Docking',    path: '/workbench/docking',           category: 'Analysis' },
  { id: 'calcs',             title: 'Equation Solver',      path: '/workbench/calcs',             category: 'Analysis' },
];
